export default {
  product: {
    title: 'Sản phẩm',
    selfCustodyWallet: 'Ví di động',
    selfCustodyWalletDesc: 'Ví di động Crypto & DeFi trên Blockchain.',
    hardwareWallet: 'Ví phần cứng',
    hardwareWalletDesc: 'Nhận KeyPal của bạn, để bảo vệ tài sản của bạn.',
    extensionWallet: 'Ví mở rộng',
    extensionWalletDesc: 'Một loại ví tốt hơn trên máy tính của bạn.',
    transit: 'Chuyển tuyến',
    transitDesc: 'Công cụ tổng hợp đa chuỗi DEX và Nền tảng thị trường NFT.',
    fiveDegrees: '5Degrees',
    fiveDegreesDesc: 'Giao thức mạng xã hội trong Web3.0.',
    stakeVault: 'ETH Staking Vault',
    stakeVaultDesc: 'Hỗ trợ cả self-custodial staking và small amount staking',
  },
  project: {
    subToken: 'Gửi Token',
    subDApp: 'Gửi DApp',
    subNFT: 'Gửi NFT',
    subChain: 'Gửi chuỗi',
  },
  assets: {
    title: 'Tài sản',
  },
  collaborations: {
    title: 'hợp tác',
  },
  community: {
    title: 'cộng đồng',
    developers: 'nhà phát triển',
    recruiting: 'TP Man',
  },
  helpCenter: {
    title: 'Hỗ trợ',
  },
  features: {
    title: 'Tính năng',
    buyCrypto: 'Mua tiền điện tử',
    mobileWallet: 'Ví di động',
    hardwareWallet: 'Ví phần cứng',
    extensionWallet: 'Ví mở rộng',
    desktop: 'Ví trên máy tính để bàn',
    fiveDegrees: '5Degrees',
    versionVerification: 'Version Verification',
    approvalDetector: 'Approval Detector',
    tokenSecurity: 'Bảo mật Token',
    keyGenerator: 'Tạo khóa',
    BATCH_SENDER: 'BatchSender',
  },
  information: {
    title: 'Thông tin',
    blockchainGuide: 'Hướng dẫn về Blockchain',
    tronWallet: 'Hướng dẫn về TRON',
    iostWallet: 'Hướng dẫn về IOST',
    tpMan: 'TP Man',
  },
  developers: {
    title: 'Nhà phát triển',
    github: 'Github (TP-Labs)',
    devCenter: 'Trung tâm phát triển',
    subToken: 'Gửi Token',
    subDApp: 'Gửi DApp',
    subNFT: 'Gửi NFT',
  },
  company: {
    title: 'Công ty',
    about: 'Giới thiệu',
    careers: 'Nghề nghiệp',
    pressKit: 'Press Kit',
    swagShop: 'Swag Shop',
  },
  support: {
    title: 'Ủng hộ',
    helpCenter: 'Trung tâm trợ giúp',
    contactUs: 'Liên hệ với chúng tôi',
  },
  legal: {
    title: 'Hợp pháp',
    privacyPolicy: 'Chính sách bảo mật',
    terms: 'Điều khoản Sử dụng',
  },
  main: {
    title: 'Xác minh Phiên bản',
    language: 'Tiếng Việt',
    intro:
      'Xác minh phiên bản được thực hiện bằng cách so khớp các giá trị băm MD5 hoặc SHA256 giữa các phiên bản. Vui lòng đảm bảo tải ví TokenPocket thông qua các kênh chính thức để tránh bị lừa đảo. Để biết hướng dẫn về cách lấy giá trị băm MD5 hoặc SHA256 của một phiên bản, vui lòng ',
    tutorial: 'xem hướng dẫn >',
    system: 'Hệ điều hành',
    android: 'Android',
    ios: 'iOS',
    version: 'Phiên bản',
    allVersion: 'Tất cả',
    appChannel: 'Kênh ứng dụng',
    developer: 'nhà phát triển',
    allChannel: 'Tất cả',
    md5: 'MD5',
    sha256: 'SHA256',
    log: 'Nhật ký Phiên bản',
    check: 'Chi tiết',
    versionLog: 'Nhật ký Phiên bản',
    confirm: 'Xác nhận',
    aboutIOS: 'Về Phiên bản iOS',
    IOSDesc:
      'Đối với phiên bản iOS, chúng tôi chỉ cung cấp ứng dụng của mình trên App Store. Chỉ có ứng dụng tải xuống thông qua App Store mới có thể được cài đặt đúng cách. Do đó, khi sử dụng thiết bị Apple, hãy đảm bảo xác thực App Store là kênh tải xuống duy nhất.',
    IOSDesc_2:
      'Nhà phát triển của phiên bản tải xuống từ App Store trước ngày 8 tháng 10 năm 2022 là TOKENPOCKET FOUNDATION LTD, đó là một phiên bản sớm được phát triển bởi TokenPocket. Đó là một ví tiền điện tử hợp pháp có thể sử dụng bình thường, nhưng dịch vụ cập nhật sẽ tạm ngừng trong một thời gian ngắn.',
    aboutAndroid: 'Về Phiên bản Android',
    androidDesc: 'Các kênh tải TokenPocket cho Android hiện tại bao gồm: trang web chính thức, Google Play Store, Samsung App Store, Huawei AppGallery, OPPO App Store và Vivo App Store. Tại một số cửa hàng ứng dụng, không thể lấy được gói cài đặt APK trong quá trình tải xuống, do đó không thể thực hiện kiểm tra MD5 hoặc SHA256. Do đó, khi tải xuống, hãy chắc chắn kiểm tra thông tin của nhà phát triển, tham khảo phía dưới!',
    IOSAppName: 'Tên ứng dụng:',
    TPWallet: 'TP Wallet',
    AppIcon: 'Biểu tượng ứng dụng:',
    AppDeveloper: 'Nhà phát triển:',
    downloadLink: 'Liên kết Tải xuống:',
    copied: 'Đã sao chép!',
    versionVerification: 'Version Verification',
  },
  follow: {
    title: 'Theo chúng tôi',
    desc1: 'Nhân viên TokenPocket sẽ không gửi tin nhắn riêng tư cho bạn!',
    desc2:
      'Thận trọng! Bạn đang tham gia cộng đồng TokenPocket, có thể có ai đó mạo danh chúng tôi để gửi tin nhắn riêng tư cho bạn! Xin lưu ý rằng bất kỳ ai gửi tin nhắn riêng tư đều có thể là kẻ lừa đảo! Chúng tôi sẽ không bao giờ liên hệ với bạn trước!',
    desc3: 'Đã hiểu, nhập',
  },
};
